<style lang="less">
.question-item {
	.answerTitle {
		background-color: #f3f4f8;
		width: 100%;
		height: 50px;
		font-size: 14px;
		color: #333333;
		line-height: 50px;
		font-weight: 500;
		h4 {
			width: 460px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-weight: normal;
			color: rgba(29, 33, 41, 1);
			text-indent: 26px;
			float: left;
			margin: 0px;
			position: relative;
			span {
				color: rgba(134, 144, 156, 1);
			}
			&:after {
				position: absolute;
				content: '';
				width: 2px;
				height: 16px;
				background: rgba(52, 145, 250, 1);
				left: 16px;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		.dataPic {
			float: right;
			display: flex;
			align-items: center;
			padding-right: 24px;
			.btn {
				display: flex;
				align-items: center;
				cursor: pointer;
				color: rgba(78, 89, 105, 1);
			}
			.line {
				width: 1px;
				height: 12px;
				background-color: rgba(201, 205, 212, 1);
				margin: 0 16px;
			}
			.iconpark-icon {
				font-size: 16px;
				fill: rgba(169, 174, 184, 1);
				margin-right: 4px;
			}
		}
	}
	.activeName {
		color: #2e9efe !important;
		.iconpark-icon {
			fill: #2e9efe !important;
		}
	}
	.icon5 {
		width: 16px !important;
		height: 16px !important;
	}
	.dataList-box {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 34px;
		.graphical {
			div {
				height: 400px;
				width: 550px;
				cursor: Default !important;
			}
			flex: 1;
		}
		.dataOption {
			flex: 1;
			float: right;
			min-width: 350px;
			line-height: 50px;
			border: 1px solid rgb(201, 205, 212);
			.dataPic {
				position: relative;
				cursor: pointer;
				display: inline-flex;
				align-items: center;
				width: 168px;
			}
			.iconpark-icon {
				font-size: 16px;
				margin-left: 4px;
			}
			.title {
				background: rgba(232, 247, 255, 1);
				color: rgba(52, 145, 250, 1);
				font-size: 14px;
				width: 100%;
				border-bottom: 1px solid rgba(229, 230, 235, 1);
				.choose {
					display: inline-block;
					padding-left: 30px;
					box-sizing: border-box;
					width: calc(~'100% - 168px');
				}
				.gross {
					padding-left: 30px;
					box-sizing: border-box;
				}
			}
			.optionList {
				height: 50px;
				color: rgba(29, 33, 41, 1);
				width: 100%;
				border-bottom: 1px solid rgba(229, 230, 235, 1);
				&:nth-last-of-type(1) {
					border: none;
				}
				.optionData {
					width: calc(~'100% - 168px');
					padding-left: 29px;
					box-sizing: border-box;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					float: left;
				}
				.signColor {
					width: 12px;
					height: 12px;
					display: inline-block;
					border-radius: 6px;
					margin-right: 8px;
					background-color: #8543e0;
				}
				.numData {
					float: left;
					width: 168px;
					padding-left: 34px;
					box-sizing: border-box;
				}
			}
		}
	}
}
</style>
<template>
	<div class="question-item">
		<div>
			<div class="answerTitle">
				<h4>
					{{ item.title }}<span>（{{ item.typeText }}）</span>
				</h4>
				<div class="dataPic">
					<span
						v-show="item.type !== 2"
						:class="{ activeName: active == '1' }"
						class="btn pieChart"
						@click="changeType(item.id, '1')"
					>
						<svg class="iconpark-icon"><use href="#bingzhuangtu"></use></svg>
						饼状图
					</span>
					<span class="line"></span>
					<span
						:class="{ activeName: active == '2' }"
						class="btn columnarGraph"
						@click="changeType(item.id, '2')"
					>
						<svg class="iconpark-icon"><use href="#zhuzhuangtu"></use></svg>
						柱形图
					</span>
					<span class="line"></span>
					<span :class="{ activeName: active == '3' }" class="btn barGraph" @click="changeType(item.id, '3')">
						<svg class="iconpark-icon"><use href="#tiaoxingtu"></use></svg>
						条形图
					</span>
				</div>
			</div>
			<div class="dataList-box">
				<div class="graphical">
					<!-- 饼状图 -->
					<echart v-show="showType == '1'" :data="dataPipe" />
					<!-- 柱形图 -->
					<echart v-show="showType == '3'" :data="dataColumn" />
					<!-- 条形图 -->
					<echart v-show="showType == '2'" :data="dataBar" />
				</div>
				<div class="dataOption">
					<div class="title">
						<span class="choose">选项</span>
						<span class="dataPic" @click="sort()">
							<span class="gross">数据量</span>
							<svg v-if="dataSort" class="iconpark-icon">
								<use href="#jiangxupaixusort-amount-down"></use>
							</svg>
							<svg v-else class="iconpark-icon"><use href="#shengxupaixusort-amount-up"></use></svg>
						</span>
					</div>
					<div v-for="(item, index) in sortData" :key="item.key" class="optionList">
						<div class="optionData">
							<span :style="{ background: [colorArray[index].color] }" class="signColor" />
							&nbsp;{{ item.key }}
						</div>
						<div class="numData">
							{{ item.value }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import echart from '../../../components/echart.vue';
const colorArray = [
	{
		color: '#e86f97',
	},
	{
		color: '#ee8d67',
	},
	{
		color: '#63c1cc',
	},
	{
		color: '#7e67ee',
	},
	{
		color: '#cc6363',
	},
	{
		color: '#80c693',
	},
	{
		color: '#669cc9',
	},
	{
		color: '#4a65ec',
	},
	{
		color: '#efd786',
	},
	{
		color: '#ebbe6c',
	},
	{
		color: '#46956A',
	},
	{
		color: '#A1973E',
	},
	{
		color: '#EE8767',
	},
	{
		color: '#26873d',
	},
	{
		color: '#6e3b58',
	},
	{
		color: '#3a4d96',
	},
	{
		color: '#27867b',
	},
	{
		color: '#8E4A45',
	},
	{
		color: '#835F80',
	},
	{
		color: '#3F8194',
	},
];
const colorList = [
	'#e86f97',
	'#ee8d67',
	'#63c1cc',
	'#7e67ee',
	'#cc6363',
	'#80c693',
	'#669cc9',
	'#4a65ec',
	'#efd786',
	'#ebbe6c',
	'#46956A',
	'#A1973E',
	'#EE8767',
	'#26873d',
	'#6e3b58',
	'#3a4d96',
	'#27867b',
	'#8E4A45',
	'#835F80',
	'#3F8194',
];
export default {
	components: {
		echart,
	},
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			colorArray,
			showType: '2',
			active: '2',
			dataSort: false,
		};
	},
	computed: {
		//柱形图
		dataBar() {
			var total = this.item.total;
			var data = {
				x: [],
				num: [],
			};
			var i = 0;
			this.sortData.forEach((e) => {
				if (e.key.length >= 4) {
					var newstr = e.key.substr(0, 4) + '...';
					data.x.push(newstr);
				} else {
					data.x.push(e.key);
				}
				if (Number.isInteger((e.value / total) * 100)) {
					data.num.push((e.value / total) * 100);
				} else {
					data.num.push(((e.value / total) * 100).toFixed(2));
				}
			});

			const rotate = data.x.length > 6 ? -40 : 0;
			const barWidth = data.x.length > 10 ? 10 : 28;
			return {
				xAxis: {
					show: true,
					data: data.x,
					axisLine: {
						// 坐标轴线
						show: true, // 默认显示，属性show控制显示与否
						lineStyle: {
							// 属性lineStyle控制线条样式
							color: '#71ecc9',
							width: 1,
							type: 'solid',
						},
					},
					axisLabel: {
						textStyle: {
							fontSize: '14',
							color: '#2b313c',
						},
						interval: 0,
						rotate,
					},
					axisTick: {
						// 坐标轴小标记
						show: false,
					},
				},
				yAxis: {
					show: true,
					splitLine: {
						// 分隔线
						show: true, // 默认显示，属性show控制显示与否
						lineStyle: {
							// 属性lineStyle（详见lineStyle）控制线条样式
							color: ['#dff0eb'],
							width: 1,
							type: 'solid',
						},
					},
					axisLine: {
						// 坐标轴线
						show: true, // 默认显示，属性show控制显示与否
						lineStyle: {
							// 属性lineStyle控制线条样式
							color: '#fff',
							width: 1,
							type: 'solid',
						},
					},
				},
				grid: {
					top: '6%',
					left: '1%',
					right: '10%',
					bottom: '20%',
				},
				series: [
					{
						type: 'bar',
						label: {
							normal: {
								show: true,
								position: 'top',
							},
						},
						data: data.num,
						barWidth,
						barMaxWidth: 30,
						itemStyle: {
							normal: {
								color: function (params) {
									return colorList[params.dataIndex];
								},
								label: {
									color: '#2b313c',
									formatter: '{c}%',
								},
							},
						},
					},
				],
				animationThreshold: false,
			};
		},
		//条形图
		dataColumn() {
			var total = this.item.total;
			var data = {
				x: [],
				num: [],
			};
			var i = 0;
			this.sortData.forEach((e) => {
				if (e.key.length >= 6) {
					var newstr = e.key.substr(0, 6) + '...';
					data.x.push(newstr);
				} else {
					data.x.push(e.key);
				}
				if (Number.isInteger((e.value / total) * 100)) {
					data.num.push((e.value / total) * 100);
				} else {
					data.num.push(((e.value / total) * 100).toFixed(2));
				}
			});

			const barWidth = data.x.length > 10 ? 10 : 28;
			return {
				calculable: true,
				xAxis: [
					{
						show: true,
						splitLine: {
							show: true,
							lineStyle: {
								color: ['#dff0eb'],
								width: 1,
								type: 'solid',
							},
						},
						axisLine: {
							// 坐标轴线
							show: true, // 默认显示，属性show控制显示与否
							lineStyle: {
								// 属性lineStyle控制线条样式
								color: '#fff',
								width: 1,
								type: 'solid',
							},
						},
					},
				],
				yAxis: [
					{
						type: 'category',
						data: data.x,
						inverse: true,
						axisLine: {
							// 坐标轴线
							show: true, // 默认显示，属性show控制显示与否
							lineStyle: {
								// 属性lineStyle控制线条样式
								color: '#71ecc9',
								width: 1,
								type: 'solid',
							},
						},
						axisLabel: {
							margin: 10,
							textStyle: {
								fontSize: '14',
								color: '#2b313c',
							},
						},
						axisTick: {
							// 坐标轴小标记
							show: false,
						},
					},
				],
				grid: {
					x: 10,
					y: 10,
					containLabel: true,
				},
				series: [
					{
						type: 'bar',
						data: data.num, //放百分比
						barWidth,
						barMaxWidth: 30,
						itemStyle: {
							normal: {
								color: function (params) {
									return colorList[params.dataIndex];
								},
								label: {
									show: true,
									position: 'right',
									color: '#2b313c',
									formatter: '{c}%',
								},
							},
						},
					},
				],
				animationThreshold: false,
			};
		},
		//饼状图
		dataPipe() {
			var total = this.item.total;
			var data = [];
			var i = 0;
			this.sortData.forEach((e) => {
				const name = e.key.length >= 6 ? e.key.substr(0, 6) + '...' : e.key;
				if (e.value) {
					data.push({
						name,
						value: Number.isInteger((e.value / total) * 100)
							? (e.value / total) * 100
							: ((e.value / total) * 100).toFixed(2),
					});
				}
			});
			return {
				title: {
					x: 'center',
				},
				series: [
					{
						type: 'pie',
						radius: '70%',
						data: data,
						labelLine: {
							normal: {
								show: false,
								length: 5,
							},
						},
						itemStyle: {
							normal: {
								color: function (params) {
									return colorList[params.dataIndex];
								},

								label: {
									textStyle: {
										fontSize: 14,
										color: '#2b313c',
										fontWeight: 'normal',
									},
									formatter: '{b}\n{c}%',
								},
							},
						},
					},
				],
				animationThreshold: false,
			};
		},
		sortData() {
			let arr = [];
			for (var key in this.item.data) {
				arr.push({
					key: key,
					value: this.item.data[key],
				});
			}
			arr.sort((a, b) => {
				if (this.dataSort) {
					return b.value - a.value;
				} else {
					return a.value - b.value;
				}
			});
			return arr;
		},
	},
	methods: {
		changeType(id, str) {
			this.showType = str;
			this.active = str;
			this.$emit('change-type', id, str);
		},
		//排序
		sort() {
			this.dataSort = !this.dataSort;
		},
	},
};
</script>
